const debug = false;

export const Setting = {
	IS_DEBUG: debug,
	USE_PROD_SERVER: !debug,
	IS_ALLOW_CHANGE_TO_RESERVED: false,
	USE_ADVANCE_SCAN: true,
	IS_GROUP_STATUS_EDITABLE: true,
	IS_NOT_SYNC_AFTER_EDIT_STATUS_IN_LIST: true,
	IS_SHOW_ASSIGN_HOME_SCREEN: false,
};
